var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
var UserService = /** @class */ (function () {
    function UserService() {
    }
    /**
     * 增加用户
     */
    UserService.prototype.createUser = function (data) {
        return this.netService.send({
            server: managementService.userController.createUser,
            data: data,
            loading: true,
        });
    };
    /**
     * 查询部门下的特定用户
     */
    UserService.prototype.getAllUsers = function (data, page) {
        return this.netService.send({
            server: managementService.userController.getAllUsers,
            data: data,
            page: page,
        });
    };
    /**
     * 用户批量分配角色
     */
    UserService.prototype.batchAllotRole = function (data) {
        return this.netService.send({
            server: managementService.userController.batchAllotRole,
            data: data,
            loading: true,
        });
    };
    /**
     * 修改用户
     */
    UserService.prototype.modifyUser = function (data) {
        return this.netService.send({
            server: managementService.userController.modifyUser,
            data: data,
            loading: true,
        });
    };
    /**
     * 重置密码
     */
    UserService.prototype.modifyUserPassword = function (_a) {
        var userId = _a.userId;
        return this.netService.send({
            server: managementService.userController.modifyUserPassword,
            data: {
                userId: userId,
            },
        });
    };
    /**
     * 批量设置催收员等级
     */
    UserService.prototype.batchUpdateUserLevel = function (data) {
        return this.netService.send({
            server: managementService.userController.batchUpdateUserLevel,
            data: data,
        });
    };
    /**
     * 批量开启关闭分案
     */
    UserService.prototype.batchCaseSwitch = function (data) {
        return this.netService.send({
            server: managementService.userController.batchCaseSwitch,
            data: data,
        });
    };
    /**
     * 根据查询所有用户不分页
     */
    UserService.prototype.getAllUsersList = function (data) {
        return this.netService.send({
            server: managementService.userController.getAllUsersList,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], UserService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], UserService.prototype, "createUser", null);
    __decorate([
        Debounce()
    ], UserService.prototype, "getAllUsers", null);
    __decorate([
        Debounce()
    ], UserService.prototype, "batchAllotRole", null);
    __decorate([
        Debounce()
    ], UserService.prototype, "modifyUser", null);
    __decorate([
        Debounce()
    ], UserService.prototype, "modifyUserPassword", null);
    __decorate([
        Debounce()
    ], UserService.prototype, "batchUpdateUserLevel", null);
    __decorate([
        Debounce()
    ], UserService.prototype, "batchCaseSwitch", null);
    return UserService;
}());
export { UserService };
